/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, CarCollectionFromJSON, CarCollectionToJSON, CarMakeDictionaryValueFromJSON, CarMakeDictionaryValueToJSON, } from './';
export function CarMakeDictionaryFromJSON(json) {
    return CarMakeDictionaryFromJSONTyped(json, false);
}
export function CarMakeDictionaryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'carCollectionId': !exists(json, 'carCollectionId') ? undefined : json['carCollectionId'],
        'carCollection': !exists(json, 'carCollection') ? undefined : CarCollectionFromJSON(json['carCollection']),
        'dictionaryValues': !exists(json, 'dictionaryValues') ? undefined : (json['dictionaryValues'] === null ? null : json['dictionaryValues'].map(CarMakeDictionaryValueFromJSON)),
    };
}
export function CarMakeDictionaryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'carCollectionId': value.carCollectionId,
        'carCollection': CarCollectionToJSON(value.carCollection),
        'dictionaryValues': value.dictionaryValues === undefined ? undefined : (value.dictionaryValues === null ? null : value.dictionaryValues.map(CarMakeDictionaryValueToJSON)),
    };
}
